function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15 1.667H5c-.917 0-1.667.75-1.667 1.666v13.334c0 .916.75 1.666 1.667 1.666h10c.917 0 1.667-.75 1.667-1.666V3.333c0-.916-.75-1.666-1.667-1.666zM5 3.333h4.167V10L7.083 8.75 5 10V3.333z"
});

function SvgClassIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20
  }, props), _ref);
}

export default SvgClassIcon;